export const chipText = {
  welcomeVideo: "No video added",
  program: "No quiz linked",
  macroCalculator: "Select a macro calculator",
  accountabilities: "Select accountabilities",
  mealPlan: "Select a meal plan",
  guides: "Select guides",
  integrations: "Select data to track",
  videos: "Select a video playlist",
  contract: "Contract not added",
  questionnaire: "No Questionnaire available",
};

export const chipTextFilled = {
  welcomeVideo: "Video added",
  program: "Quiz linked",
  macroCalculator: "Macro calculator selected",
  accountabilities: "Accountability templates selected",
  mealPlan: "Meal plans selected",
  guides: "Guides selected",
  integrations: "Integrations selected",
  videos: "Video playlist selected",
  contract: "Contract added",
  questionnaire: "Onboarding Questionnaire Created",
};

export const optionFields = {
  welcomeVideo: "video",
  program: "url",
  macroCalculator: "widget",
  accountabilities: "widget",
  mealPlan: "widget",
  guides: "widget",
  integrations: "items",
  videos: "playlist",
  progressPhotos: "_id",
  bodyweight: "_id",
  goals: "_id",
  contract: "contract",
  questionnaire: "questions",
};

export const btnText = {
  welcomeVideo: "Add",
  program: "Link",
  macroCalculator: "Select",
  accountabilities: "Select",
  mealPlan: "Select",
  guides: "Select",
  integrations: "Select",
  videos: "Select",
  goals: "Read more",
  contract: "Add",
  questionnaire: "Add",
};

export const btnTextFilled = {
  welcomeVideo: "Edit",
  program: "Edit",
  macroCalculator: "Edit",
  accountabilities: "Edit",
  mealPlan: "Edit",
  guides: "Edit",
  integrations: "Edit",
  videos: "Edit",
  goals: "Read more",
  contract: "Edit",
  questionnaire: "Edit",
};

export const optionDescription = {
  welcomeVideo:
    "Kickstart your users journeys with a welcome video and show them how to make the most of their experience with your app",
  program:
    "Share a questionnaire with your users to help them find a program that suits them",
  macroCalculator:
    "Select a macro calculator from your widgets to provide goal-specific nutrition targets for your app users",
  accountabilities:
    "Select an accountability template from your widgets to create a list of habits for users of your app",
  mealPlan:
    "Select a meal plan from your widgets to create a personalized meal plan for your app users",
  guides:
    "Select a guide from your widgets to share any content or education with users of your app",
  integrations:
    "Allow users of your app to sync health and fitness data from their favorite apps to track and report on their progress",
  videos:
    "Select a video playlist from your widgets to share any content or education with users of your app",
  progressPhotos:
    "Take users of your app to the upload progress photos feature so they can keep track of their body transformation as they progress through their workout plan",
  bodyweight:
    "Prompt users to log their bodyweight progress over time, allowing them to monitor changes and stay motivated",
  goals:
    "Give users the ability to define and track goals, whether it's steps, bodyweight, sleep or any custom goal",
  contract: "Add a contract to your app to ensure users agree to your terms",
  questionnaire:
    "Add an onboarding questionnaire for new users to complete to collect information",
};

export const integrationItems = [
  "bodyweight",
  "steps",
  "nutritions",
  "sleep",
  "hrv",
];

export const integrationItemLabels = {
  bodyweight: "Daily bodyweight",
  steps: "Daily step count",
  nutritions: "Daily nutrition intake",
  sleep: "Daily sleep",
  hrv: "Daily heart rate variability (HRV)",
};

/**
 * Return the text for the button based on the option and whether or not it has been filled.
 *
 * @param {string} option - The option from the getting started options (e.g. welcomeVideo, program, etc.)
 * @param {bool} isFilled - Whether or not the option has been filled.
 * @returns {string} - The button text based on whether or not the option has been filled.
 */
export const getBtnText = (option, isFilled) => {
  return isFilled ? btnTextFilled[option] : btnText[option];
};

/**
 * Return the text for the chip based on the option and whether or not it has been filled.
 *
 * @param {string} option - The option from the getting started options (e.g. welcomeVideo, program, etc.)
 * @param {bool} isFilled - Whether or not the option has been filled.
 * @returns {string} - The chip text based on whether or not the option has been filled.
 */
export const getChipText = (option, isFilled) => {
  return isFilled ? chipTextFilled[option] : chipText[option];
};

export const OPTION_NAME_MAP = {
  welcomeVideo: "Welcome Video",
  program: "Find the right program",
  macroCalculator: "Calculate your macro targets",
  accountabilities: "Set your daily accountabilities",
  mealPlan: "Select your meal plan",
  guides: "Read guides",
  integrations: "Integrate your app",
  goals: "Set your goals",
  progressPhotos: "Upload progress photos",
  bodyweight: "Upload bodyweight",
  videos: "Watch Videos",
  contract: "Contract",
  questionnaire: "Onboarding Questionnaire",
};

export const pushOptions = {
  welcomeVideo: { status: "draft" },
  program: { status: "draft" },
  macroCalculator: { status: "draft" },
  accountabilities: { status: "draft" },
  mealPlan: { status: "draft" },
  guides: { status: "draft" },
  integrations: { status: "draft" },
  goals: { status: "draft" },
  progressPhotos: { status: "draft" },
  bodyweight: { status: "draft" },
  videos: { status: "draft" },
};

export const pullOptions = {
  welcomeVideo: { status: "draft" },
  contract: { status: "draft" },
  macroCalculator: { status: "draft" },
  accountabilities: { status: "draft" },
  mealPlan: { status: "draft" },
  guides: { status: "draft" },
  integrations: { status: "draft" },
  goals: { status: "draft" },
  progressPhotos: { status: "draft" },
  bodyweight: { status: "draft" },
  videos: { status: "draft" },
  questionnaire: { status: "draft" },
};
